'use client';

import { useEffect } from 'react';

import { Loader } from '@polyai/ui/components/atoms/Loader';

const ParagonOAuthRedirect = () => {
  useEffect(() => {
    // Get all query parameters from the current URL
    const params = new URLSearchParams(window.location.search);

    // Redirect to Paragon's OAuth endpoint with all query parameters
    const paragonOAuthUrl = `https://passport.useparagon.com/oauth?${params.toString()}`;

    window.location.href = paragonOAuthUrl;
  }, []);

  return <Loader inProjectPage={false} fullScreen logo />;
};

export default ParagonOAuthRedirect;
